import { alignElementToMousePointer, elementClassListAdd, showElement } from '../../../utils/htmlElement.utils';
import { WEB_COMPONENT_GZ_TOOLTIP_BOX } from '../../../webcomponents.constants';
import { GzTooltipBoxWebComponent } from './GzTooltipBoxWebComponent';
import { isEmpty } from '@nirvana/shared/basic-types/object';

export class GzTooltip {
  private static tooltip: GzTooltipBoxWebComponent | null;

  public static show(text: string, event: MouseEvent, stateClass?: string) {
    if (!text || isEmpty(text)) {
      return;
    }

    GzTooltip.tooltip = this.buildTooltipBox(text, event, stateClass);

    if (!GzTooltip.tooltip) {
      return;
    }

    showElement(GzTooltip.tooltip);
  }

  private static buildTooltipBox(
    text: string | null,
    event: MouseEvent,
    stateClass?: string | null
  ): GzTooltipBoxWebComponent | null {
    const tooltipBoxes = window.document.getElementsByTagName(WEB_COMPONENT_GZ_TOOLTIP_BOX);

    if (tooltipBoxes.length > 0) {
      GzTooltip.hide();
    }

    if (!text || isEmpty(text)) {
      return null;
    }

    const tooltipBoxRef = new GzTooltipBoxWebComponent(event);
    tooltipBoxRef.text = text;

    if (typeof stateClass === 'string') {
      elementClassListAdd(tooltipBoxRef, 'tooltip-' + stateClass);
    }

    document.body.appendChild(tooltipBoxRef);

    window.addEventListener('scroll', GzTooltip.hide);

    return tooltipBoxRef;
  }

  public static align(event: MouseEvent) {
    if (!GzTooltip.tooltip) {
      return;
    }
    alignElementToMousePointer(event, GzTooltip.tooltip);
  }

  public static hide() {
    if (!GzTooltip.tooltip) {
      return;
    }

    GzTooltip.tooltip.remove();
    GzTooltip.tooltip = null;

    window.removeEventListener('scroll', GzTooltip.hide);
  }
}
